const DEFAULT_MESSAGE_TEMPLATE_DIALOG_VALUES = {
  template_name: '',
  message: ''
};

export default DEFAULT_MESSAGE_TEMPLATE_DIALOG_VALUES;
